module.exports = __webpack_public_path__ + "img/x.39bb55cf.svg";